export interface InboxContact {
  name: string;
  hasUnreadMessages: boolean;
  linkedInURL: string;
  profileId?: string;
  occupation: string;
}

export interface InboxMessage {
  date: number;
  direction: MessageDirections;
  text: string;
  messageType?: MessageTypes;
}

export interface InboxCampaign {
  _id: string;
  name: string;
  unreadMessagesCount: number;
  timeZone: string;
  linkedinAccount: {
    _id: string;
    userEmail: string;
    firstName?: string;
    lastName?: string;
  };
}

export enum FilterOptions {
  ACTIVE_CAMPAIGNS = 'active',
  NOT_ACTIVE_CAMPAIGNS = 'notActive',
  ARCHIVED_CAMPAIGNS = 'archived',
}

export enum MessageTypes {
  EMAIL = 'email',
  LINKEDIN = 'linkedin',
}

export enum MessageDirections {
  SENT = 'sent',
  RECEIVED = 'received',
}
